/* Mobile enhancements keep native scrolling, links and details controls. */
(() => {
 const mobile=matchMedia('(max-width:989px)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const mounted=new WeakSet();
 function mountNavigation(root=document){
  root.querySelectorAll('[data-gx-department-nav]').forEach(nav=>{
   if(mounted.has(nav))return;mounted.add(nav);
   const row=nav.querySelector('.gx-department-nav__row');if(!row)return;
   const items=[...row.children];if(items.length<2)return;
   let visible=true,raf=0,last=0,position=row.scrollLeft,holdUntil=0,touch=false;
   const enabled=()=>mobile.matches&&!reduced.matches&&visible&&!document.hidden&&row.scrollWidth>row.clientWidth+8;
   function pause(ms=6500){holdUntil=performance.now()+ms;last=0;}
   function restore(){items.forEach(item=>row.append(item));row.scrollLeft=0;position=0;last=0;}
   function frame(now){
    raf=0;if(!enabled()){last=0;return;}
    raf=requestAnimationFrame(frame);
    const focused=row.querySelector(':focus-visible');
    if(touch||now<holdUntil||nav.querySelector('details[open]')||focused){last=0;position=row.scrollLeft;return;}
    if(!last){last=now;position=row.scrollLeft;return;}
    position+=22*Math.min((now-last)/1000,.05);last=now;
    let first=row.firstElementChild;
    // Move the same real menu item to the end after it leaves the viewport.
    // No duplicate menus, links, IDs or empty end of track.
    while(first&&position>=first.getBoundingClientRect().width){
     const width=first.getBoundingClientRect().width;if(width<=0)break;
     row.append(first);position-=width;first=row.firstElementChild;
    }
    row.scrollLeft=position;
   }
   function sync(){
    if(!mobile.matches||reduced.matches){if(raf)cancelAnimationFrame(raf);raf=0;restore();return;}
    if(enabled()&&!raf){last=0;raf=requestAnimationFrame(frame);}
    else if(!enabled()&&raf){cancelAnimationFrame(raf);raf=0;last=0;}
   }
   row.addEventListener('pointerdown',()=>{touch=true;pause();},{passive:true});
   window.addEventListener('pointerup',()=>{if(touch){touch=false;pause();}},{passive:true});
   window.addEventListener('pointercancel',()=>{if(touch){touch=false;pause();}},{passive:true});
   row.addEventListener('touchstart',()=>{touch=true;pause();},{passive:true});
   row.addEventListener('touchend',()=>{touch=false;pause();},{passive:true});
   row.addEventListener('touchcancel',()=>{touch=false;pause();},{passive:true});
   row.addEventListener('wheel',()=>pause(),{passive:true});
   row.addEventListener('keydown',()=>pause(),{passive:true});
   row.addEventListener('focusin',()=>pause(),{passive:true});
   nav.addEventListener('toggle',()=>pause(2500),true);
   document.addEventListener('visibilitychange',sync);
   mobile.addEventListener('change',sync);reduced.addEventListener('change',sync);
   new ResizeObserver(sync).observe(row);
   new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();}).observe(nav);
   sync();
  });
 }
 const lastSheen=new WeakMap();
 document.addEventListener('pointerdown',event=>{
  if(!mobile.matches||reduced.matches||!['touch','pen'].includes(event.pointerType))return;
  const button=event.target.closest('[data-gx-card]')?.querySelector('[data-gx-buy]');
  if(!button||button.disabled)return;
  const now=performance.now();if(now-(lastSheen.get(button)??-2000)<1250)return;
  lastSheen.set(button,now);button.classList.add('gx-touch-sheen');
  setTimeout(()=>button.classList.remove('gx-touch-sheen'),1200);
 },{passive:true});
 function videoPreviewFallback(root=document){
  root.querySelectorAll('.product__description img').forEach(img=>{
   const link=img.closest('a');if(!link)return;
   try{if(!/(^|\.)youtu(be\.com|\.be)$/.test(new URL(link.href).hostname)||!/(^|\.)ebayimg\.com$/.test(new URL(img.src).hostname))return;}catch{return;}
   const replace=()=>{if(!img.isConnected)return;const label=document.createElement('span');label.className='gx-product-video-label';label.textContent='View video on YouTube →';img.replaceWith(label);};
   const inspect=()=>{if(img.naturalWidth<=80&&img.naturalHeight<=80)replace();};
   if(img.complete)inspect();else{img.addEventListener('load',inspect,{once:true});img.addEventListener('error',replace,{once:true});}
  });
 }
 mountNavigation();videoPreviewFallback();
 document.addEventListener('shopify:section:load',event=>{mountNavigation(event.target);videoPreviewFallback(event.target);});
})();
